/**
 * Shared auth-pane spacing. Width picks the base scale (phones roomier, tablet
 * and up tighter); from md up, viewport height then compacts it on laptops
 * (≤900px tall) and opens it up on tall screens (1080p and above).
 */
/** md+ and short (1440×900, 1536×864 and below): keep the sign-up column scroll-free. */
export const AUTH_SHORT = "@media (min-width:900px) and (max-height:900px)";
/** md+ and very short: 1366×768, 1280×720 and 1024×768. */
export const AUTH_SHORTEST = "@media (min-width:900px) and (max-height:780px)";
/**
 * sm+ and short enough that stacked Company name / domain would scroll (real
 * laptop viewports ≤840px tall): those fields pair up and the hint moves to a tooltip.
 */
export const AUTH_COMPACT_ROW = "@media (min-width:600px) and (max-height:840px)";
/** md+ and tall: room to breathe (13" MacBooks at 956–982 sit in between). */
export const AUTH_TALL = "@media (min-width:900px) and (min-height:1000px)";
/** lg+ and tall: 1080p-class monitors, where headings scale up. */
export const AUTH_WIDE_TALL = "@media (min-width:1200px) and (min-height:1000px)";

/** Between heading, Google block, divider and form. Spread into `sx`. */
export const authSectionGapSx = {
  gap: { xs: 3, sm: 2 },
  [AUTH_SHORT]: { gap: 1.5 },
  [AUTH_SHORTEST]: { gap: 1 },
  [AUTH_TALL]: { gap: 3 },
};
/** Between form fields (and within side-by-side field rows). Spread into `sx`. */
export const authFieldGapSx = {
  gap: { xs: 2, sm: 1.5 },
  [AUTH_SHORT]: { gap: 1.25 },
  [AUTH_SHORTEST]: { gap: 1 },
  [AUTH_TALL]: { gap: 2 },
};
